/**
 * Prompt Library Page
 * Prompt management and library for admins and teachers
 *
 * Premium Version (Full Deployment): Shows PromptLibraryWithUpload (with tabs + file upload)
 * Core Version: Shows basic PromptManagement
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { PromptManagement } from '../components/admin/PromptManagement';
import { loadPromptLibraryWithUpload } from '../utils/componentLoader';
import { isFullDeployment } from '../utils/deploymentMode';

export const PromptLibrary: React.FC = () => {
  const { t } = useTranslation();

  // Try to load Premium version with upload functionality
  if (isFullDeployment()) {
    const PremiumPromptLibrary = loadPromptLibraryWithUpload();
    return <div data-testid="prompts-content"><PremiumPromptLibrary /></div>;
  }

  // Fallback: Core version without upload
  return (
    <div className="space-y-6" data-testid="prompts-content">
      {/* Header */}
      <div>
        {/* TF-506: H1 nutzt den Sidebar-Key, damit Titel und Navigation synchron bleiben */}
        <h1 className="text-3xl font-bold text-gray-900">
          {t('nav.sidebar.promptLibrary')}
        </h1>
        <p className="text-gray-600 mt-2">
          {t('pages.promptLibrary.subtitle')}
        </p>
      </div>

      {/* Prompt Management Component */}
      <div className="card p-6">
        <PromptManagement />
      </div>
    </div>
  );
};
